module.exports = __webpack_public_path__ + "static/media/logo.ccc258f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/App/images/logo.svg
// module id = 653
// module chunks = 0